module.exports = __webpack_public_path__ + "img/vac-icon.c0cd848b.svg";